import { render, staticRenderFns } from "./PublisherSettingsAI.vue?vue&type=template&id=ddae21e2&lang=pug"
import script from "./PublisherSettingsAI.vue?vue&type=script&lang=js"
export * from "./PublisherSettingsAI.vue?vue&type=script&lang=js"
import style0 from "./PublisherSettingsAI.vue?vue&type=style&index=0&id=ddae21e2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports